// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8MIsw","inner":"styles_inner__2pOMV","right":"styles_right__WQLEh","close":"styles_close__29VGm","footer":"styles_footer__ukwqj"};